import {ReportCheckoutHistoryModel} from "../../models/reports/ReportCheckoutHistoryModel";

export class ReportCheckoutHistoryCtrl {
    public static $inject = ['$scope','ReportCheckoutHistoryModel'];
    constructor(public $scope:any, public model:ReportCheckoutHistoryModel) {
        $scope.vm = this;
        this.$scope.$watch(() => [this.model.assetname, this.model.username, this.model.startDate, this.model.endDate],(newValue: string, oldValue: string) => {
            this.model.getCount();
        },true);
    }
}
